import { create } from "zustand";

  const useLanguageStore = create((setLanguage)=>({
    language:[],
    // selectedLangauge:{},
    selectedLangaugeData:{},
    setLanguage : setLanguage
  }))

  export default useLanguageStore;